import { create } from "zustand";

type UpdatedAtByProject = Record<string, number | undefined>;

interface DoclistUpdatedAtState {
  updatedAtByProject: UpdatedAtByProject;

  // Set updatedAt for a project
  setUpdatedAt: (projectId: string, updatedAt: number | undefined) => void;

  // Get updatedAt for a project
  getUpdatedAt: (projectId: string) => number | undefined;

  // Clear updatedAt for a project
  clearUpdatedAt: (projectId: string) => void;
}

export const useDoclistUpdatedAtStore = create<DoclistUpdatedAtState>(
  (set, get) => ({
    updatedAtByProject: {},

    setUpdatedAt: (projectId: string, updatedAt: number | undefined) => {
      set((state) => ({
        updatedAtByProject: {
          ...state.updatedAtByProject,
          [projectId]: updatedAt,
        },
      }));
    },

    getUpdatedAt: (projectId: string) => {
      return get().updatedAtByProject[projectId];
    },

    clearUpdatedAt: (projectId: string) => {
      set((state) => {
        const { [projectId]: _, ...rest } = state.updatedAtByProject;
        return { updatedAtByProject: rest };
      });
    },
  })
);
